import { NgClass } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

import { IFlashMessage } from '../../model';

@Component({
  selector: 'app-flash-message',
  template: `
    @if (payload(); as data) {
      <mat-card class="p-4" [ngClass]="classMap()" appearance="outlined">
        <div [innerHTML]="data.message"></div>
      </mat-card>
    }
  `,
  imports: [MatCardModule, NgClass],
})
export class FlashMessageComponent {
  payload = input.required<IFlashMessage | null | undefined>();
  panelClass = input<string>();

  classMap = computed(() => {
    const data = this.payload();
    return data ? `${data.type.toLowerCase()} ${this.panelClass()}`.trim() : this.panelClass();
  });
}
